import Button from "@material-ui/core/Button"
import Checkbox from "@material-ui/core/Checkbox"
import Container from "@material-ui/core/Container"
import CssBaseline from "@material-ui/core/CssBaseline"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import InputAdornment from "@material-ui/core/InputAdornment"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Snackbar from "@material-ui/core/Snackbar"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import CancelIcon from "@material-ui/icons/Cancel"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import { default as AlertFixo, default as MuiAlert } from "@material-ui/lab/Alert"
import { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { silenciarAvisoTodasAbas } from "../../components/OperacaoTempoReal"
import useParametros from "../../contexts/ParametrosContext"
import { RecebedorContextProvider } from "../../contexts/RecebedorContext"
import api from "../../services/api"
import { RegistrarLogErro } from "../../services/clientefiel"
import {
    atualizarStatus,
    atualizarTempoEntrega,
    buscarestabelecimentos,
    buscarRedeDeEstabelecimentos,
    ObterStatusLojaIfood,
    ResumoDia,
} from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import { autoAceiteLigado } from "../../stores/ConfigsStore"
import {
    forcarImpressaoNavegador,
    marcarResyncResolvido,
    resyncJaResolvido,
} from "../../stores/ImpressaoStore"
import useLoadingStore from "../../stores/LoadingStore"
import { useSnackbar } from "../../utils/notificacoes"
import Cabecalho from "../Cabecalho"
import Loading from "../Componentes/Loading"
import { useStreamPedidosCompartilhado } from "../PedidosDoDia/useStreamPedidosCompartilhado"
import BotoesUtilitarios from "./components/BotoesUtilitarios"
import ConfiguracaoImpressao from "./components/ConfiguracaoImpressao"
import DialogCancelamento from "./components/DialogCancelamento"
import DialogInformacoesPedido from "./components/DialogInformacoesPedido"
import FiltroEntregaRetirada from "./components/FiltroEntregaRetirada"
import FiltroMesa from "./components/FiltroMesa"
import Transition from "./components/Transition"
import { pedidoTravado } from "./functions"
import ListaIntegracoes from "./Integracoes/ListaIntegracoes"
import Print from "./print"
import { imprimirNotaFiscal } from "./qzConfig"
import "./styles.css"
import Lista from "./tabelas/Lista"
const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    fixedRegistrador: {
        position: "fixed",
        left: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedStatus: {
        position: "fixed",
        left: "2em",
        bottom: "7em",
        zIndex: 1000,
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    adicionarImpressora: { height: "100%", width: "100%", padding: "15px 14px" },
    impressaoComandaCompleta: {
        width: "100%",
        margin: "0",
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
        "& > *": { flex: 1 },
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const formatter = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

export const listaCancelamento99food = [
    { cod: "1010", description: "Item esgotado" },
    { cod: "1020", description: "Loja fechada" },
    { cod: "1030", description: "A loja está muito ocupada para preparar a refeição" },
    {
        cod: "1040",
        description: "Impossível preparar a refeição devido a falhas de água ou energia",
    },
    { cod: "1050", description: "Cancelamento por solicitação do cliente" },
    { cod: "1060", description: "Sem entregador disponível." },
    { cod: "1080", description: "Outro motivo" },
]

export default function RecebedorDePedidos() {
    const theme = useTheme()
    const history = useHistory()
    const classes = useStyles()
    const params = useParametros()

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const autorizacao = localStorage.getItem("chaveSistema")

    const buscarPedidos = useAppStore(s => s.buscarPedidos)
    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const [valorEntregasFuiApp, setValorEntregasFuiApp] = useState(false)
    const [modalChamarEntregadorFui, setModalChamarEntregadorFui] = useState(false)
    const [formaPagamentoSelecionadaFui, setFormaPagamentoSelecionadaFui] = useState({})

    const [openConfirmacaoPedidosRepetidosFui, setOpenConfirmacaoPedidosRepetidosFui] =
        useState(false)
    const [
        messageOpenConfirmacaoPedidosRepetidosFui,
        setMessageOpenConfirmacaoPedidosRepetidosFui,
    ] = useState("")
    const [pedidosEntregaFuiApp, setPedidosEntregaFuiApp] = useState([])
    const [statusLojaIfood, setStatusLojaIfood] = useState({})
    const [statusLoja99, setStatusLoja99] = useState({})
    const [filaPrints, setFilaPrints] = useState([])
    const [contratar, setContratar] = useState(false)

    const tabStatus = useAppStore(s => s.tabStatus)
    const setTabStatus = useAppStore(s => s.setTabStatus)

    useEffect(() => {
        localStorage.setItem("tabStatus", tabStatus)
    }, [tabStatus])

    useEffect(() => {
        // Não rebaixa o terminal do garçom: se a estação já está em GARCOM (celular do
        // garçom), entrar no Recebimento mantém o modo Garçom em vez de forçar Visualização.
        if (mobile && useAppStore.getState().tabStatus !== "GARCOM") setTabStatus("VIEW")
    }, [])

    const impressorasQZ = useAppStore(s => s.impressorasQZ)

    const [modalEntregadorFuiDelivery, setModalEntregadorFuiDelivery] = useState({
        openModal: false,
    })
    const busqueiTodosPedidos = useRef(true)
    const [modalInformacoesPedido, setModalInformacoesPedido] = useState({})
    const [arraySegundo, setArraySegundo] = useState([])
    const [confirmarCancelamento, setConfirmarCancelamento] = useState(null)

    // Lista ÚNICA (fonte de verdade das colunas). Usada aqui para o som de novo pedido,
    // o resync e o banner de pedidos parados no preparo automático.
    const arrayTodosPedidos = useAppStore(s => s.arrayTodosPedidos)
    // Pedidos cujo aceite/preparo automático falhou: entram no banner na hora.
    const pedidosComFalhaAcao = useAppStore(s => s.pedidosComFalhaAcao)

    const [loadingPedidos, setLoadingPedidos] = useState(true)

    const [expandListaIntegracoes, setExpandListaIntegracoes] = useState(false)

    const { user, printer, recebedor } = configuracoes

    const imprimirPedidoMesa = recebedor.imprimirPedidoMesa ?? true

    // Preferência POR NAVEGADOR: forçar impressão nativa mesmo com o QZ disponível.
    const [forcarNavegador] = useState(forcarImpressaoNavegador())
    const tipoPainelImpressao = forcarNavegador
        ? "navegador"
        : impressorasQZ.length > 0
        ? "plugin" //qz
        : window.navigator.userAgent.includes("Electron")
        ? "software" //exe
        : "navegador" //padrao do navegador

    const { parametros } = user

    const [modalIfoodConfig, setModalIfoodConfig] = useState(false)
    const [modalConfiguracoes, setModalConfiguracoes] = useState(false)
    const setLoading = useLoadingStore(s => s.setLoading)
    const [alert, setAlert] = useState({ status: false, tipo: "success", mesangem: "" })

    const [estabelecimentos, setEstabelecimentos] = useState([])
    const [openEstabelecimentos, setOpenEstabelecimentos] = useState(false)

    const mandarImprimir = useAppStore(s => s.mandarImprimir)
    const buscarImpressoras = useAppStore(s => s.buscarImpressoras)

    // ── Tempo real (substitui o polling fixo de 5s) ──
    // Quando o aceite automático está ativo (Sempre/Tela aberta), o tempo real
    // fica forçado ligado (precisa dos eventos para aceitar/imprimir). Quando
    // está desligado, o usuário controla; a preferência é lembrada por navegador.
    const autoAceite = autoAceiteLigado(recebedor)
    const [tempoRealUsuario] = useState(
        () => localStorage.getItem("recebedorTempoReal") !== "false"
    )
    const tempoRealLigado = autoAceite || tempoRealUsuario

    const listaMotivoCancelamento =
        confirmarCancelamento?.plataforma === "didi_food"
            ? listaCancelamento99food
            : parametros.listaMotivoCancelamento

    const tipoPrinter =
        tipoPainelImpressao === "plugin"
            ? printer.tipoImpressao
                ? printer.tipoImpressao
                : "code"
            : ""
    const tamanhoFonteSelect = printer.tamanhoFonteSelect ? printer.tamanhoFonteSelect : "media"

    const exibirTamanhoFonte = tipoPrinter === "html"
    const exibirImprimirLogo = tipoPrinter === "code"
    const exibirSeletorTamanho = tipoPrinter === "code"
    const exibir99food = tipoPrinter === "code" || tipoPrinter === "html"

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const alertClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlert({ status: false, tipo: alert.tipo, mesangem: alert.mesangem })
    }

    const changeCheckFuiApp = (isChecked, identificador) => {
        const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

        if (isChecked) {
            pedidos.push(identificador)
            setPedidosEntregaFuiApp(pedidos)
        } else {
            const index = pedidos.indexOf(identificador)
            pedidos.splice(index) //remove
            setPedidosEntregaFuiApp(pedidos)
        }
    }
    const checkPedidoAgrupaFuiAppDelivery = (pedidoEscolhido, identificador, bairro) => {
        var isSameIdCheck = pedidoEscolhido?.id === identificador

        if (isSameIdCheck && pedidosEntregaFuiApp?.indexOf(identificador) === -1) {
            changeCheckFuiApp(isSameIdCheck, identificador)
        }

        var show = pedidosEntregaFuiApp?.indexOf(identificador) !== -1 || isSameIdCheck

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        checked={show}
                        onChange={e => {
                            var checked = e.target.checked
                            const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

                            if (checked) {
                                pedidos.push(identificador)
                                setPedidosEntregaFuiApp(pedidos)
                            } else {
                                const index = pedidos.indexOf(identificador)
                                pedidos.splice(index) //remove
                                setPedidosEntregaFuiApp(pedidos)
                            }
                        }}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        name={identificador.toString()}
                        id={identificador.toString()}
                    />
                }
                label={"#" + identificador + " (" + bairro + ")"}
            />
        )
    }

    const showCheckbox = pedidoEscolhido => {
        var rows = []
        var qnt = arraySegundo.length
        for (var i = 0; i < qnt; i++) {
            const lista = arraySegundo
            const item = lista[i]
            var bairro = "--"
            if (item?.deliveryAddress?.neighborhood) {
                bairro = item?.deliveryAddress?.neighborhood
            }
            rows.push(checkPedidoAgrupaFuiAppDelivery(pedidoEscolhido, item.id, bairro))
        }
        return <Container>{rows}</Container>
    }

    const validarPedidosJaEnviadosFuiDelivery = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/validarPedidosJaEnviados/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    setLoading(false)
                    if (response.status === 200) {
                        calcularValorEntregaFuiApp()
                    } else {
                        alertStart("Erro ao validar pedido", "error")
                    }
                })
                .catch(error => {
                    setLoading(false)
                    let response = error.response.data
                    setOpenConfirmacaoPedidosRepetidosFui(true)
                    setMessageOpenConfirmacaoPedidosRepetidosFui(response.message)
                })
        } catch (error) {
            setLoading(false)
            RegistrarLogErro(error, "validarPedidosJaEnviados", pedidosEntregaFuiApp)
        }
    }

    const calcularValorEntregaFuiApp = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/consultarValor/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    if (typeof response.data === "string") {
                        alertStart("Erro ao consultar valores", "error")
                    } else {
                        const retorno = response.data
                        setValorEntregasFuiApp(retorno)
                        setModalChamarEntregadorFui(true)
                    }
                    setLoading(false)
                })
        } catch (error) {
            let response = error.response.data
            alertStart(response.message, "error")
            setLoading(false)
            RegistrarLogErro(error, "consultarValorEntrega", pedidosEntregaFuiApp)
        }
    }

    const chamarEntregadorFui = async (entregaObj, servicoId, formaPagamentoId) => {
        setLoading(true)

        try {
            const body = {
                calculoResponse: entregaObj.calculoResponse,
                entregaParam: entregaObj.entregaParam,
                calculaParam: entregaObj.calculaParam,
                servicoFuiApp: servicoId,
                tipoPagamentoFuiApp: formaPagamentoId,
            }

            await api
                .post(`entrega/fuiAppDelivery/solicitarEntrega/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    if (typeof response.data === "string") {
                        alertStart("Não foi possivel solicitar a entrega", "error")
                    } else {
                        const retorno = response.data
                        alertStart(retorno.message, "success")
                        // setValorEntregasFuiApp(retorno)
                        // setModalChamarEntregadorFui(true);
                    }
                    setLoading(false)
                })
                .catch(error => {
                    let response = error.response.data
                    alertStart(response.message, "error")
                })
            setLoading(false)
        } catch (error) {
            setLoading(false)
            alertStart(error, "error")
            RegistrarLogErro(error, "solicitarEntrega", { entregaObj, servicoId, formaPagamentoId })
        }
    }

    const showDialogConfirmarValoresFui = () => {
        return (
            <Dialog
                fullScreen={fullScreen}
                open={modalChamarEntregadorFui}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    setFormaPagamentoSelecionadaFui(null)
                    setModalChamarEntregadorFui(false)
                }}
            >
                <DialogTitle>{"Confirmar Dados Entrega"}</DialogTitle>
                <DialogContent>
                    {valorEntregasFuiApp?.calculoResponse?.enderecoOrigem ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Origem</h4>
                            </Typography>
                            <Typography>
                                {" * " + valorEntregasFuiApp?.calculoResponse?.enderecoOrigem}
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Destino(s)</h4>
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos?.map((destino, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{" * " + destino.endereco}</Typography>
                        </Col>
                    ))}

                    {!valorEntregasFuiApp?.calculoResponse?.servicos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                Infelizmente não encontramos serviços referente à sua solicitação
                            </Typography>
                        </Col>
                    ) : null}

                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "60%" }}
                        >
                            <InputLabel id="pagamentofuiapp">Pagamento</InputLabel>
                            <Select
                                fullWidth
                                onChange={e => {
                                    setFormaPagamentoSelecionadaFui({
                                        name: e.target.name,
                                        id: e.target.value,
                                    })
                                }}
                                label="Forma de Pagamento"
                            >
                                {valorEntregasFuiApp?.formasPagamentoDisponiveis?.map(
                                    (formaPagamentoFui, index) => (
                                        <MenuItem
                                            name={formaPagamentoFui?.tipoPagamentoDesc}
                                            value={formaPagamentoFui?.tipoPagamentoID}
                                            key={formaPagamentoFui?.tipoPagamentoID}
                                        >
                                            <em>{formaPagamentoFui?.tipoPagamentoDesc}</em>
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                    </Col>

                    {valorEntregasFuiApp?.calculoResponse?.servicos?.map((servico, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{"-------------------------"}</Typography>
                            <Typography>
                                {servico.servicoNome}
                                {" -- "}
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(servico.valor)}
                                <Button
                                    onClick={() => {
                                        if (!formaPagamentoSelecionadaFui?.id) {
                                            alertStart("Escolha a forma de pagamento", "error")
                                            return
                                        }
                                        chamarEntregadorFui(
                                            valorEntregasFuiApp,
                                            servico,
                                            formaPagamentoSelecionadaFui.id
                                        )
                                        setModalChamarEntregadorFui(false)
                                    }}
                                >
                                    Solicitar
                                </Button>
                            </Typography>
                        </Col>
                    ))}
                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        {"-------------------------"}
                    </Col>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setFormaPagamentoSelecionadaFui(null)
                            setModalChamarEntregadorFui(false)
                        }}
                    >
                        Voltar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const desenvolvimento =
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("192.168")

    useEffect(() => {
        const efeitoAtivo = window.getCookie("efeito-sonoro-ativo")
            ? window.getCookie("efeito-sonoro-ativo") === "true"
            : true

        document.querySelector("#audiopedido")?.load()

        const imprimir99 = window.getCookie("imprimir-99")
            ? window.getCookie("imprimir-99") === "true"
            : true

        if (efeitoAtivo !== printer.efeitoSonoro) {
            atualizarConfiguracoes({ recebedor: { efeitoSonoro: efeitoAtivo } })
            window.setCookie("efeito-sonoro-ativo", efeitoAtivo, 9999)
        }

        if (imprimir99 !== printer.imprimir99automatico) {
            atualizarConfiguracoes({ printer: { imprimir99automatico: imprimir99 } })
            window.setCookie("imprimir-99", imprimir99, 9999)
        }
    }, [])

    useEffect(() => {
        try {
            buscarTodosPedidos(localStorage.getItem("chaveSistema"))
            verificarSeTemQZ()
        } catch (error) {
            RegistrarLogErro(error, "userEffect1")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabStatus])

    useEffect(() => {
        try {
            const rootPrint = document.getElementById("rootPrint")

            switch (configuracoes.printer.tamanhoFonteNavegador) {
                case "normal":
                    rootPrint.classList.remove("textoImpressaoGrande")
                    break

                case "grande":
                    rootPrint.classList.add("textoImpressaoGrande")
                    break
            }

            if (tabStatus === "CRUD") {
                const interval = setInterval(() => {
                    verificarSeTemQZ()
                }, 20000)
                return () => clearInterval(interval)
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect3")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [impressorasQZ, configuracoes, tabStatus])

    const [estabelecimentosRede, setEstabelecimentosRede] = useState(null)

    useEffect(() => {
        const handleBuscarRedeDeEstabelecimentos = async () => {
            try {
                setLoading(true)
                const response = await buscarRedeDeEstabelecimentos(autorizacao)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    setLoading(false)
                    return false
                }
                setEstabelecimentosRede(response)
                setLoading(false)
            } catch (error) {
                RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
            }
        }

        if (!estabelecimentosRede) {
            handleBuscarRedeDeEstabelecimentos()
        }
    }, [])

    const hasIfood = parametros?.ativaIntegracaoIfood

    useEffect(() => {
        let intervalLojaIFood
        // let intervalLoja99

        if (tabStatus === "CRUD") {
            if (hasIfood) {
                try {
                    verificarStatusLojaIfood(autorizacao)
                    intervalLojaIFood = setInterval(function () {
                        verificarStatusLojaIfood(autorizacao)
                    }, 30000)
                } catch (error) {}
            }
        }

        return () => {
            clearInterval(intervalLojaIFood)
            // clearInterval(intervalLoja99)
        }
    }, [autorizacao, parametros])

    // SSE como fonte de tempo real (NÃO usa mais o eventspolling / ACK, para não
    // consumir a fila das integrações por polling). Só reage com o Tempo real ligado
    // e a aba em modo CRUD. A conexão SSE é única por navegador (Web Locks),
    // compartilhada com o Cabeçalho e a Pedidos do Dia. O stream é da conta inteira
    // (modo login); esta tela lista todos os estabelecimentos do fornecedor
    // (integracao/orders/allday), então NÃO filtra por estabelecimento.
    useStreamPedidosCompartilhado(autorizacao, evento => {
        // Evento de IMPRESSÃO empurrado (aceite/impressão automática): SÓ em operação
        // (CRUD) e com o tempo real ligado. Em Visualização nunca aceita nem imprime.
        // Não dá ACK (não consome a fila do servidor).
        //
        // Os eventos LEVES (PLACED = novo pedido, STATUS = troca de status) NÃO são
        // tratados aqui: o OperacaoTempoReal — global, montado pelo Cabeçalho nesta mesma
        // aba — já os busca UMA vez por navegador (só a aba LÍDER busca) e repassa às
        // demais por BroadcastChannel. Tratá-los aqui também fazia a mesma aba buscar o
        // mesmo pedido em duplicidade (e cada aba do Painel buscava por conta própria).
        if (evento?.kind === "IMPRESSAO") {
            if (tempoRealLigado && tabStatus === "CRUD") {
                useAppStore.getState().processarEventoImpressao(evento)
            }
        }
    })

    // forcar: só o clique manual no "Atualizar" força o refresh sem cache no backend (ver
    // buscarTodosPedidos). As atualizações internas após uma ação (mudar status na lista) chamam
    // atualizar() sem forçar — a própria ação já invalidou o cache daquele pedido.
    const atualizar = (loading = false, forcar = false) => {
        try {
            if (loading) {
                setLoadingPedidos(true)
            }
            //faz pull indiana
            if (parametros?.ativarIndiana) {
                var objPullIndiana = {
                    codigoFilial: parametros?.codigoFilialIndiana,
                    codigoEmpresa: parametros?.codigoEmpresaEntregaIndiana,
                }
                buscaPedidosIntegracaoIndiana(autorizacao, objPullIndiana)
            } else {
                buscarTodosPedidos(autorizacao, forcar)
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizar")
        }
    }

    async function atualizarTempoEntregaEstabelecimento(tempo, estabelecimento, index) {
        try {
            estabelecimento.tempoEntregaTexto = tempo
            const response = await atualizarTempoEntrega(autorizacao, estabelecimento)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].tempoEntregaTexto = response.tempoEntregaTexto
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }
    async function atualizarStatusEstabelecimento(e, estabelecimento, index) {
        try {
            const data = {
                idEstabelecimento: estabelecimento.id,
                situacao: e.target.value,
            }
            const response = await atualizarStatus(autorizacao, data)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].situacao = response.situacao
            novoEstabelecimentos[index].pausado = response.pausado
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }

    const solicitarEntregaFuiDelivery = async (Authorization, pedido) => {
        setModalEntregadorFuiDelivery({
            ...modalEntregadorFuiDelivery,
            openModal: true,
            pedidoSelecionado: pedido,
        })
    }

    const handleBuscarDadosEstabelecimentos = async modificar => {
        try {
            setLoading(true)
            const response = await buscarestabelecimentos(autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setEstabelecimentos(response)
            if (modificar) setOpenEstabelecimentos(true)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        }
        return {}
    }

    // A impressão pelo NAVEGADOR (window.print) sem QZ é disparada uma única vez no
    // estágio de PREPARO, dentro de prepararPedido (fallbackNavegador) — manual ou
    // automático. O efeito antigo que imprimia aqui ao ACEITAR foi removido: ele abria
    // o diálogo de impressão no aceite e depois duplicava no preparar.

    // Total de pendentes do render anterior: detecta a TRANSIÇÃO "tinha pedido → esvaziou"
    // para avisar as outras abas uma única vez (e não a cada re-render com a lista vazia).
    const pendentesAntesRef = useRef(0)
    useEffect(() => {
        // Quando parar o som de novo pedido:
        //  - AUTOMÁTICO (aceite/preparo): o pedido é aceito sozinho e "descansa" em
        //    "Aceito" até o operador clicar em PREPARAR. Enquanto houver pedido em
        //    Aguardando OU Aceito, ainda há algo a atender → mantém o som. Só para
        //    quando AMBAS esvaziam. Considerar as duas listas evita que a reconciliação
        //    periódica (allday a cada 2 min) silencie o som no instante em que o pedido
        //    "pisca" de volta para Aguardando antes do aceite reprocessar.
        //  - MANUAL: o som chama até o operador ACEITAR; ao esvaziar Aguardando, para.
        // Deriva os pendentes da lista ÚNICA por status (0=Aguardando, 1/2=Aceito):
        //  - AUTOMÁTICO: status 0, 1 ou 2 conta como pendente.
        //  - MANUAL: só status 0 (Aguardando).
        const pendentes = (arrayTodosPedidos || []).filter(p =>
            autoAceiteLigado(recebedor)
                ? p.status === 0 || p.status === 1 || p.status === 2
                : p.status === 0
        ).length

        if (!pendentes) {
            desativarAviso()
            // Acabou de esvaziar (tinha pendente → agora zero): avisa as OUTRAS abas para
            // pararem o som também, igual ao clique na bandeja. Antes, aceitar/preparar
            // parava o som só NESTA aba e as demais seguiam tocando até reconciliar. Só na
            // TRANSIÇÃO (>0 → 0), para não re-silenciar uma aba que voltou a tocar por um
            // pedido novo.
            if (pendentesAntesRef.current > 0) silenciarAvisoTodasAbas()
        }
        pendentesAntesRef.current = pendentes
    }, [arrayTodosPedidos, recebedor])

    const updatePedidosRecebidos = useAppStore(s => s.updatePedidosRecebidos)

    // ── Resync com confirmação ──
    // Ao abrir/atualizar a tela, oferece imprimir os pedidos que ainda estão em
    // situação 0 (Aguardando Aceitação) e não tiveram a impressão identificada
    // nesta estação. Só faz sentido sem auto-handling: com aceite automático OU
    // preparo automático ligado, o próprio updatePedidosRecebidos já aceita/prepara
    // e imprime os pendentes no carregamento. Requer QZ configurado (plugin).
    const [resyncPedidos, setResyncPedidos] = useState([])

    const verificarResync = () => {
        try {
            const store = useAppStore.getState()
            const cfg = store.configuracoes
            if (!cfg) return
            if (autoAceiteLigado(cfg.recebedor) || cfg.recebedor.prepararPedidoAutomatico) return
            if (store.tipoPainelImpressao() !== "plugin") return

            const candidatos = (store.arrayTodosPedidos || []).filter(p => {
                if (p.status !== 0) return false
                if (resyncJaResolvido(p.id)) return false
                if (p.imprimir === false) return false
                if (
                    cfg.printer.imprimirComandasIfood === false &&
                    p.plataforma === "ifood_integracao"
                )
                    return false
                if (cfg.printer.imprimir99automatico === false && p.didiOrderUUID) return false
                return true
            })

            if (candidatos.length > 0) setResyncPedidos(candidatos)
        } catch (error) {
            RegistrarLogErro(error, "verificarResync")
        }
    }

    const confirmarResyncImprimir = () => {
        const store = useAppStore.getState()
        resyncPedidos.forEach(pedido => {
            store.mandarImprimir({ pedido, texto: pedido.texto, reimpressaoManual: true })
            marcarResyncResolvido(pedido.id)
        })
        setResyncPedidos([])
    }

    const dispensarResync = () => {
        resyncPedidos.forEach(pedido => marcarResyncResolvido(pedido.id))
        setResyncPedidos([])
    }

    // ── Rede de segurança a cada 2 min ──
    // Movida para o store (redeSegurancaPedidos) e disparada por um intervalo GLOBAL no
    // Cabeçalho, que está montado em toda tela — inclusive aqui. Assim a rede vale também
    // em Mesas/Registrador, onde antes não existia e um push SSE perdido fazia o pedido
    // expirar sem aparecer nem ser aceito. Não replicamos o intervalo aqui para não
    // duplicar o polling allday quando o Recebedor está aberto.

    const buscaPedidosIntegracaoIndiana = async (Authorization, body) => {
        try {
            await api
                .post(`indiana/pull/all`, body, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    updatePedidosRecebidos(response)
                })
        } catch (error) {
            RegistrarLogErro(error, "buscaPedidosIntegracaoIndiana", body)
            alertStart("Erro ao buscar todos os Buscar Pedidos da Indiana!", "error")
            return false
        } finally {
            // Sempre encerra o loading, mesmo em erro (ver buscarTodosPedidos).
            setLoadingPedidos(false)
        }
    }

    // forcar=true (clique no "Atualizar"): o backend reconstrói cada pedido ignorando o cache
    // do DTO e sobrescreve a entrada — corrige na hora um pedido que ficou preso no cache com
    // status transitório (99/77). O carregamento automático (inicial, rede de segurança) chama
    // sem forçar, para não reconstruir todos os DTOs a cada ciclo.
    const buscarTodosPedidos = async (Authorization, forcar = false) => {
        try {
            setLoading(true)
            await api
                .get(`integracao/orders/allday${forcar ? "?forcar=true" : ""}`, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    updatePedidosRecebidos(response)
                    verificarResync()
                })
        } catch (error) {
            RegistrarLogErro(error, "buscarTodosPedidos")
            alertStart("Erro ao buscar todos os pedidos!", "error")
            return false
        } finally {
            // Sempre encerra o loading — mesmo se o carregamento/impressão lançar (ex.: erro
            // do QZ). Antes, o setLoadingPedidos(false) só rodava no sucesso, então qualquer
            // exceção deixava as colunas "carregando pra sempre".
            setLoadingPedidos(false)
            setLoading(false)
        }
    }

    const verificarSeTemQZ = () => {
        try {
            //console.log('|||||||||||| verificar se tem qz')
            if (qz.websocket.isActive()) {
                buscarImpressoras()
            } else {
                qz.websocket
                    .connect()
                    .then(() => {
                        qz.printers
                            .details()
                            .then(function (data) {
                                for (var i = 0; i < data.length; i++) {}
                            })
                            .catch(function (e) {
                                console.error(e)
                            })

                        //console.log('Conectado QZ!');
                        buscarImpressoras()
                    })
                    .catch(err => {
                        console.error("Erro QZ", err.message)
                        // alertStart("Impressao automatica não identifica!", "error")
                        if (tipoPainelImpressao === "plugin") {
                            // TODO:
                            // setImpressorasQZ([])
                        }
                    })
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarSeTemQZ")
        }
    }

    const verificarStatusLojaIfood = async Authorization => {
        const retorno = await ObterStatusLojaIfood(parametros?.estabelecimento, Authorization)

        if (retorno.retornoErro) {
            setStatusLojaIfood({
                title: "...",
                message: "...",
            })
            return false
        }

        setStatusLojaIfood({
            title: retorno?.available ? "Loja Aberta" : "Loja Fechada",
            message: retorno?.message,
            extraInfo: retorno?.extraInfo,
        })
    }

    const buscarInformacoesPedido = async (Authorization, pedido) => {
        //console.log('buscarInformacoesPedido', pedido)
        var retorno = {}
        try {
            await api
                .get(`integracao/orders/${pedido.correlationId}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                        //"fixed_token_ifood": hashInternaClienteFielIfood, //deprecated
                        // "ifood_integration_active": ativaIntegracaoIfood //deprecated
                    },
                })
                .then(response => {
                    //console.log("buscarInformacoesPedido", response.data)
                    response.data.evento = pedido
                    retorno = response.data
                })
        } catch (error) {
            RegistrarLogErro(error, "buscarInformacoesPedido", pedido)
        }
        return retorno
    }

    const buscarStatus = pedido => {
        /* 
      AGUARDANDO_ACEITACAO = 0;
      ACEITO = 1;
      CONFIRMACAO_VISUALIZADA = 2;
      EM_ENTREGA = 3;
      ENTREGUE = 4;
      PAGO = 5;
      PRONTO = 6;
      EM_PRODUCAO = 7;
      AGUARDANDO ATUALIZAR STATUS = 10;

      CANCELADO_PELO_DISTRIBUIDOR = -1;
      CANCELADO_PELO_CLIENTE = -2;
      NAO_ENTREGUE = -3;
      EXPIRADO = -4;
      CHARGEBACK = -10;
    */
        switch (pedido.status) {
            case 0:
                return "Aguardando Aceitação"
            case 1:
            case 2:
                return "Aceito"
            case 3:
                if (pedido.type === "1") return "Em Retirada"
                return "Em Entrega"
            case 4:
                return "Entregue"
            case 5:
                return "Pago"
            case 6:
                if (pedido.type === "2") return "Em Entrega"
                return "Em Retirada"
            case 7:
                return "Preparação"
            case -1:
                return "Loja Cancelou"
            case -2:
                return "Cliente Cancelou"
            case -3:
                return "Não Entregue"
            case -4:
                return "Expirado"
            case -10:
                return "ChargeBack"

            // Status "ocultos"/transitórios: normalmente não chegam a renderizar (o painel
            // os filtra via statusOcultoDoPainel), mas se um card ficar preso nesses estados
            // mostramos um rótulo claro em vez do genérico "Não Identificado".
            case 10:
                return "Atualizando Status"
            case 77:
                return "Aguardando Pagamento"
            case 99:
                return "Cadastrado"

            default:
                return "Não Identificado"
        }
    }

    const resumoDoDia = async () => {
        const res = await ResumoDia(autorizacao)

        // Necessário porque função de imprimir remove as duas primeiras quebras de linha
        let textos =
            "\n\n" +
            res.message
                .replaceAll(
                    "<hr/>",
                    `
-----------------------`
                )
                .replaceAll("<br/>", "\n")
                .replaceAll(/(-----)([^-])/g, "$1\n$2")
                // O gerador do servidor usa marcadores markdown para ênfase
                // (*título*, **seção**, _canal_). Nenhum caminho de impressão
                // (navegador/QZ) os interpreta, então saíam literais na comanda.
                // Remove os marcadores, mantendo o texto limpo.
                .replaceAll("**", "")
                .replaceAll(/\*(.*?)\*/g, "$1")
                .replaceAll(/_(.*?)_/g, "$1")

        mandarImprimir({
            texto: textos,
            qtd: 1,
            isResumo: true,
        })
    }

    // TODO: Mover para RecebedorContext
    const mudarStatusPara = async (status, autorizacao, pedido, index, imprimir = true) => {
        try {
            switch (status) {
                case -1:
                    setConfirmarCancelamento(pedido)
                    break
                case 1:
                    await aceitarPedido(pedido, imprimir)
                    break
                case 7:
                    await prepararPedido(pedido, imprimir)
                    break
                case 3:
                    await despacharPedido(pedido)
                    break
                case 6:
                    await retirarPedido(pedido)
                    break
                case 4:
                    await finalizarPedido(pedido)
                    break

                default:
                    break
            }
        } catch (error) {
            RegistrarLogErro(error, "mudarStatusPara", { status, pedido })
        }
    }

    const desativarAviso = useAppStore(s => s.desativarAviso)

    const aceitarPedido = useAppStore(s => s.aceitarPedido)
    const prepararPedido = useAppStore(s => s.prepararPedido)
    const despacharPedido = useAppStore(s => s.despacharPedido)
    const retirarPedido = useAppStore(s => s.retirarPedido)
    const finalizarPedido = useAppStore(s => s.finalizarPedido)

    const handleCloseEstabelecimentos = () => {
        const tempoEntregaElements = document.getElementsByClassName("tempoEntrega")
        for (let i = 0; i < tempoEntregaElements.length; i++) {
            const element = tempoEntregaElements[i].firstChild.firstChild

            if (element.value.length > 10) {
                alertStart("Tempo de entrega deve ter um máximo de 10 caracteres", "error")
                return
            }

            atualizarTempoEntregaEstabelecimento(
                element.value,
                estabelecimentos[element.dataset?.indexEstabelecimento],
                element.dataset?.indexEstabelecimento
            )
        }
        setOpenEstabelecimentos(false)
    }

    if (recebedor.exibirTempoEspera === undefined)
        atualizarConfiguracoes({ recebedor: { exibirTempoEspera: true } })

    const painelInstalado = sessionStorage.getItem("direcionamentoInicial")
    const [filtroAgendado, setFiltroAgendado] = useState(0)

    // ── Banner de pedidos parados (nos modos AUTOMÁTICOS) ──
    // Nesses modos os estágios iniciais não aparecem na coluna 1 (são feitos sozinhos):
    // preparo automático oculta 0/1/2; aceite automático oculta o 0 (Aguardando). Se um
    // pedido não avança sozinho (a rotina falhou ou avançou só um passo), ele ficaria
    // invisível. Detectamos os que TRAVAM (pedidoTravado, em functions.js) e os mostramos
    // num aviso no topo, com ação para aceitar/preparar manualmente. A rede de segurança
    // (reofertarAceitePendentes) ainda tenta reprocessá-los sozinha a cada ciclo.
    //  - preparo automático → considera parados os status 0, 1 e 2;
    //  - aceite automático  → considera parado só o status 0 (1 e 2 já aparecem na coluna).
    //
    // O MESMO predicado (mesmo limite) devolve esses pedidos para a coluna 1 em
    // colunaDoPedido: o banner é o aviso, o card é a ação — os dois aparecem juntos.
    const [tickTravados, setTickTravados] = useState(0)
    const [dialogTravados, setDialogTravados] = useState(false)

    const preparoAuto = recebedor.prepararPedidoAutomatico === true
    const aceiteAuto = autoAceiteLigado(recebedor)
    const modoAutomatico = preparoAuto || aceiteAuto

    useEffect(() => {
        if (!modoAutomatico) return
        // Reavalia a idade dos pedidos periodicamente (a lista não muda sozinha enquanto
        // um pedido está travado, então precisamos de um tick para o cronômetro correr).
        const interval = setInterval(() => setTickTravados(t => t + 1), 20000)
        return () => clearInterval(interval)
    }, [modoAutomatico])

    const pedidosTravados = useMemo(() => {
        if (!modoAutomatico) return []
        // Preparo auto some com 0/1/2 da coluna; aceite auto some só com o 0.
        const statusParados = preparoAuto ? [0, 1, 2] : [0]
        return (arrayTodosPedidos || []).filter(
            p =>
                statusParados.includes(p.status) &&
                (pedidoTravado(p) || pedidosComFalhaAcao.includes(p.id))
        )
        // tickTravados força o recálculo periódico da idade.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayTodosPedidos, tickTravados, modoAutomatico, preparoAuto, pedidosComFalhaAcao])

    // A coluna "Aceito" (1) é ocultada no PREPARO automático — os estágios iniciais são
    // feitos sozinhos. Mas quando algum pedido TRAVA nesses estágios ela precisa voltar:
    // colunaDoPedido manda o travado para a coluna 1 e, sem ela na tela, o pedido ficava
    // só no banner, sem card nem botão. Foi o que aconteceu com duas estações abertas (uma
    // em aceite automático, outra em preparo): a de preparo exibia o aviso e mais nada.
    // No aceite automático a coluna 1 sempre existiu, então nada muda por lá.
    const exibirColunaAceito = !preparoAuto || pedidosTravados.length > 0
    const tamanhoLista = exibirColunaAceito ? 3 : 4

    // Fecha o diálogo quando não há mais pedidos travados (evita diálogo vazio ao resolver
    // o último manualmente ou pela retentativa automática).
    useEffect(() => {
        if (dialogTravados && pedidosTravados.length === 0) setDialogTravados(false)
    }, [dialogTravados, pedidosTravados.length])

    return (
        <RecebedorContextProvider atualizar={atualizar}>
            {/* Registrador e Mesas agora abrem como PÁGINA (navegação por rota, igual ao
                menu), substituindo o Recebedor — não são mais overlays em iframe. Os botões
                em BotoesUtilitarios chamam os handlers do ServicosContext. A impressão/aceite
                segue rodando via Cabeçalho (SSE + rede de segurança global). */}
            <Container
                component="main"
                maxWidth="lg"
                className="distanciaTop"
                style={{
                    minHeight: "120vh",
                    paddingLeft: mobile ? "" : "var(--drawer-width, 80px)",
                    transition: "padding-left 0.2s ease",
                }}
            >
                <Cabecalho pagina="Painel de Pedidos" />

                <Print filaPrints={filaPrints} setFilaPrints={setFilaPrints} />

                <Dialog open={resyncPedidos.length > 0} onClose={dispensarResync}>
                    <DialogTitle>Imprimir pedidos não identificados?</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Estes pedidos ainda não tiveram a impressão identificada nesta estação.
                            Deseja imprimir?
                        </DialogContentText>
                        {resyncPedidos.map(pedido => (
                            <Typography key={pedido.id}>
                                #{pedido.shortReference || pedido.id}
                                {pedido.plataforma ? ` — ${pedido.plataforma}` : ""}
                                {pedido.customer?.name ? ` — ${pedido.customer.name}` : ""}
                            </Typography>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={dispensarResync}>Não imprimir</Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={confirmarResyncImprimir}
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                </Dialog>

                <Loading />

                <Snackbar open={alert.status} autoHideDuration={6000} onClose={alertClose}>
                    <Alert onClose={alertClose} severity={alert.tipo}>
                        {alert.mesangem}
                    </Alert>
                </Snackbar>

                <CssBaseline />

                <Dialog
                    open={contratar}
                    onClose={() => {
                        setContratar(false)
                    }}
                >
                    <DialogTitle>{"Contato para Contratar"}</DialogTitle>
                    <DialogContent>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        window.open(
                                            "https://api.whatsapp.com/send?phone=5531994754366&text=Oi%20tudo%20bem?%20Gostaria%20de%20saber%20como%20funciona%20o%20registrador%20de%20pedidos%20para%20contratar.",
                                            "_blank"
                                        )
                                        setContratar(false)
                                    }}
                                    style={{ backgroundColor: "#075E54", color: "white" }}
                                    fullWidth
                                    variant="contained"
                                >
                                    Contactar por Whatsapp
                                </Button>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        setContratar(false)
                                    }}
                                    fullWidth
                                    style={{ marginTop: "1em" }}
                                >
                                    Não quero
                                </Button>
                            </Col>
                        </Row>
                    </DialogContent>
                </Dialog>

                {tabStatus === "VIEW" ? (
                    <Row style={{ width: "100%", margin: "0" }}>
                        <AlertFixo
                            severity="warning"
                            style={{ width: "100%", marginBottom: "1em" }}
                        >
                            Você está em <b>modo visualização</b> (não aceita pedidos nem imprime as
                            comandas que chegam)
                            <Button
                                color="default"
                                onClick={() => {
                                    setTabStatus("CRUD")
                                }}
                            >
                                Ativar Modo Operação
                            </Button>
                        </AlertFixo>
                    </Row>
                ) : null}

                {pedidosTravados.length > 0 ? (
                    <Row style={{ width: "100%", margin: "0" }}>
                        <AlertFixo
                            severity="warning"
                            style={{ width: "100%", marginBottom: "1em" }}
                        >
                            {pedidosTravados.length}{" "}
                            {pedidosTravados.length === 1
                                ? "pedido não avançou automaticamente"
                                : "pedidos não avançaram automaticamente"}{" "}
                            (parados aguardando/aceito).
                            <Button color="default" onClick={() => setDialogTravados(true)}>
                                Ver
                            </Button>
                        </AlertFixo>
                    </Row>
                ) : null}

                <Dialog open={dialogTravados} onClose={() => setDialogTravados(false)}>
                    <DialogTitle>Pedidos que não avançaram</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            No preparo automático a coluna "Aceito" fica oculta. Estes pedidos
                            seguem parados — o sistema tenta reprocessá-los sozinho, mas você pode
                            aceitá-los/prepará-los manualmente aqui.
                        </DialogContentText>
                        {pedidosTravados.map(pedido => {
                            // status 0 (Aguardando) → botão "Aceitar" (→1); status 1/2 (Aceito)
                            // → botão "Preparar" (→7). Espelha a lógica do card. O diálogo NÃO
                            // fecha: a lista se atualiza sozinha e você age em vários pedidos.
                            const aceito = pedido.status === 1 || pedido.status === 2
                            return (
                                <Row
                                    key={pedido.id}
                                    style={{
                                        margin: "0",
                                        padding: "0.5em 0",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderBottom: "1px solid #eee",
                                    }}
                                >
                                    <Typography>
                                        #{pedido.shortReference || pedido.id}
                                        {pedido.customer?.name ? ` — ${pedido.customer.name}` : ""}
                                        {` (${buscarStatus(pedido)})`}
                                    </Typography>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={() =>
                                            mudarStatusPara(aceito ? 7 : 1, autorizacao, pedido)
                                        }
                                    >
                                        {aceito ? "Preparar" : "Aceitar"}
                                    </Button>
                                </Row>
                            )
                        })}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogTravados(false)}>Fechar</Button>
                    </DialogActions>
                </Dialog>

                <Row style={{ flexDirection: "row", paddingInline: "15px", gap: "1rem" }}>
                    <TextField
                        style={{ background: "#fff", flex: "1 1 12rem" }}
                        id="procurar-pedido-alternativo"
                        onChange={e => buscarPedidos(e.target.value)}
                        label="Procurar"
                        variant="outlined"
                        size="small"
                    />
                    <FiltroEntregaRetirada />
                    <FiltroMesa />

                    {params.PUBLIC_HABILITAR_AGENDAMENTO && (
                        <FormControl variant="outlined" style={{ minWidth: "130px" }}>
                            <InputLabel>Agendados</InputLabel>
                            <Select
                                defaultValue={0}
                                value={filtroAgendado?.target?.value}
                                onChange={e => setFiltroAgendado(e)}
                                variant="outlined"
                                style={{ maxHeight: "40px" }}
                                label="agendado"
                            >
                                <MenuItem value={0}>Todos</MenuItem>
                                <MenuItem value={1}>Não agendados</MenuItem>
                                <MenuItem value={2}>Agendados</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    <BotoesUtilitarios
                        estabelecimentos={estabelecimentos}
                        expandListaIntegracoes={expandListaIntegracoes}
                        setExpandListaIntegracoes={setExpandListaIntegracoes}
                        resumoDoDia={resumoDoDia}
                        handleBuscarDadosEstabelecimentos={handleBuscarDadosEstabelecimentos}
                        setModalConfiguracoes={setModalConfiguracoes}
                        atualizar={atualizar}
                    />
                </Row>
                <Row>
                    {exibirColunaAceito ? (
                        <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                            <Lista
                                tipoPainelImpressao={tipoPainelImpressao}
                                indexLista={1}
                                solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                                buscarStatus={buscarStatus}
                                loading={loadingPedidos}
                                classes={classes}
                                autorizacao={autorizacao}
                                impressorasQZ={impressorasQZ}
                                setModalInformacoesPedido={setModalInformacoesPedido}
                                mudarStatusPara={mudarStatusPara}
                                imprimirNotaFiscal={imprimirNotaFiscal}
                                alertStart={alertStart}
                                estabelecimentosRede={estabelecimentosRede}
                                filtroAgendado={filtroAgendado}
                            />
                        </Col>
                    ) : null}

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={2}
                            loading={loadingPedidos}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={3}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={4}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <DialogCancelamento
                        listaMotivoCancelamento={listaMotivoCancelamento}
                        confirmarCancelamento={confirmarCancelamento}
                        setConfirmarCancelamento={setConfirmarCancelamento}
                        alertStart={alertStart}
                        setLoading={setLoading}
                    />

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalIfoodConfig}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalIfoodConfig(false)
                        }}
                    >
                        <DialogTitle>{"Dados iFood"}</DialogTitle>
                        <DialogContent>
                            <Col
                                xs={12}
                                md={12}
                                lg={12}
                                style={{ marginBottom: "1em", textAlign: "center" }}
                            >
                                <Typography>
                                    {statusLojaIfood?.title
                                        ? statusLojaIfood?.title
                                        : "--- Sem informações ---"}
                                </Typography>

                                <Typography>{statusLojaIfood?.message}</Typography>
                            </Col>

                            {statusLojaIfood?.extraInfo?.map((info, index) => (
                                <Col
                                    key={index}
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ marginBottom: "1em", textAlign: "center" }}
                                >
                                    <Typography>{info ? " * " + info : "---"}</Typography>
                                </Col>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalIfoodConfig(false)
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalConfiguracoes}
                        TransitionComponent={Transition}
                        keepMounted
                        maxWidth="md"
                        fullWidth
                        onClose={() => {
                            setModalConfiguracoes(false)
                        }}
                    >
                        <ConfiguracaoImpressao onFechar={() => setModalConfiguracoes(false)} />
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openEstabelecimentos}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleCloseEstabelecimentos}
                    >
                        <DialogTitle>{"Configurações dos Estabelecimentos"}</DialogTitle>
                        <DialogContent>
                            {estabelecimentos.map((estabelecimento, index) => (
                                <Row key={index}>
                                    <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        style={{ marginBottom: "1em", textAlign: "center" }}
                                    >
                                        <Typography>{estabelecimento.nome}</Typography>
                                    </Col>
                                    <Col xs={12} md={6} lg={6} style={{ marginBottom: "1em" }}>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                            fullWidth
                                        >
                                            <InputLabel htmlFor="outlined-age-native-simple">
                                                Status
                                            </InputLabel>
                                            <Select
                                                native
                                                value={
                                                    estabelecimento.situacao === 1 &&
                                                    estabelecimento.pausado
                                                        ? 2
                                                        : estabelecimento.situacao
                                                }
                                                fullWidth
                                                label="Status"
                                                style={{ padding: 0 }}
                                                onChange={e => {
                                                    atualizarStatusEstabelecimento(
                                                        e,
                                                        estabelecimento,
                                                        index
                                                    )
                                                }}
                                                endAdornment={
                                                    <InputAdornment
                                                        position="end"
                                                        style={{
                                                            position: "absolute",
                                                            left: "15px",
                                                        }}
                                                    >
                                                        {estabelecimento.situacao === 1 &&
                                                        estabelecimento.pausado ? (
                                                            <PauseCircleFilledIcon
                                                                style={{ color: "#ffc107" }}
                                                            />
                                                        ) : estabelecimento.situacao === 0 ? (
                                                            <CancelIcon
                                                                style={{ color: "#dc3545" }}
                                                            />
                                                        ) : (
                                                            <PlayCircleFilledIcon
                                                                style={{ color: "#28a745" }}
                                                            />
                                                        )}
                                                    </InputAdornment>
                                                }
                                                inputProps={{
                                                    name: "Status",
                                                    id: "select-status-estabelecimento",
                                                }}
                                            >
                                                <option value={1}>Aberto</option>
                                                <option value={0}>Fechado</option>
                                                <option value={2}>Pausado</option>
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col xs={12} md={6} lg={6}>
                                        <TextField
                                            className="tempoEntrega"
                                            variant="outlined"
                                            placeholder="Tempo de entrega"
                                            helperText="Exemplo: 45-60 min"
                                            defaultValue={estabelecimento.tempoEntregaTexto}
                                            inputProps={{
                                                "data-index-estabelecimento": index,
                                            }}
                                        />
                                    </Col>
                                    <Divider className={"divisaoEstabelecimentos"}></Divider>
                                </Row>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseEstabelecimentos}>Voltar</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openConfirmacaoPedidosRepetidosFui}
                        onClose={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Informativo"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {messageOpenConfirmacaoPedidosRepetidosFui}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                                color="default"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    calcularValorEntregaFuiApp()
                                    setOpenConfirmacaoPedidosRepetidosFui(false)
                                }}
                                color="primary"
                                autoFocus
                            >
                                Consultar mesmo assim
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalEntregadorFuiDelivery?.openModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setPedidosEntregaFuiApp([])
                            setModalEntregadorFuiDelivery({
                                ...modalEntregadorFuiDelivery,
                                openModal: false,
                                pedidoSelecionado: null,
                            })
                        }}
                    >
                        <DialogTitle>{"Fui App Delivery"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                <>
                                    <Col xs={12} md={12} lg={12}>
                                        <Typography variant="body2" component="p">
                                            Agrupar com outros pedidos
                                        </Typography>

                                        {showCheckbox(
                                            modalEntregadorFuiDelivery?.pedidoSelecionado
                                        )}
                                    </Col>
                                </>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    validarPedidosJaEnviadosFuiDelivery()
                                }}
                            >
                                Calcular Valor
                            </Button>
                            <Button
                                onClick={() => {
                                    setPedidosEntregaFuiApp([])
                                    setModalEntregadorFuiDelivery({
                                        ...modalEntregadorFuiDelivery,
                                        openModal: false,
                                        pedidoSelecionado: null,
                                    })
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {showDialogConfirmarValoresFui()}

                    <DialogInformacoesPedido mudarStatusPara={mudarStatusPara} />
                </Row>
                <ListaIntegracoes
                    expandListaIntegracoes={expandListaIntegracoes}
                    setExpandListaIntegracoes={setExpandListaIntegracoes}
                    statusLojaIfood={statusLojaIfood}
                    statusLoja99={statusLoja99}
                    estabelecimentos={estabelecimentos}
                />
            </Container>
        </RecebedorContextProvider>
    )
}
